  
import course from './course.vue'



export {course} 


// WEBPACK FOOTER //
// ./src/pages/course/index.js